import { fetchAuthSession } from 'aws-amplify/auth';

export const getAuthState = async (): Promise<'authenticated' | 'unauthenticated'> => {
  const session = await fetchAuthSession();
  return session.tokens !== undefined ? 'authenticated' : 'unauthenticated';
};
